<h3>Prüfungszeiten FA-Lehrgang</h3>
<ng-container *ngLet="faoTimeExpenditures$ | async as faoTimeExpenditures">
    <cna-loading-spinner
        *ngIf="faoLoading$ | async; else content"
    ></cna-loading-spinner>
    <ng-template #content>
        <p-table
            [value]="faoTimeExpenditures"
            dataKey="faoTitle"
            [autoLayout]="true"
            rowExpandMode="single"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Titel</th>
                    <th>Lernzeiten</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <p>Dieser Kurs hat keine FAO Kapitel</p>
            </ng-template>
            <ng-template pTemplate="body" let-fao let-expanded="expanded">
                <tr>
                    <td>
                        <strong>{{ fao.faoTitle }}</strong>
                    </td>
                    <td *ngIf="fao.timeExpenditures.length > 0; else noTimes">
                        <p *ngFor="let timeExpenditure of fao.timeExpenditures">
                            {{ timeExpenditure.date | date: 'dd.MM.yyyy' }}
                            {{ timeExpenditure.duration | secondsToHours }}
                        </p>
                    </td>
                    <ng-template #noTimes>
                        <td>
                            <p>noch keine Lernzeiten erfasst</p>
                        </td>
                    </ng-template>
                </tr>
                <tr>
                    <td>Lernzeit</td>
                    <td>
                        {{ fao.duration | secondsToHours }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</ng-container>
